import { Component, Input, OnInit,  } from '@angular/core';

@Component({
  selector: 'g-columnCheckbox',
  templateUrl: './columnCheckbox.component.html',
})
export class ColumnCheckboxComponent implements OnInit {
  constructor() { }

  private _data: any;
  @Input() set data(s: any) {
    this._data = s === true ? true : null;
  }
  get data() {
    return this._data;
  }

  @Input() isEditing: boolean = false;

  ngOnInit() { }
}
